module.exports = "/static/media/link_icon.195b3231.svg";